"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var react_2 = require("react");
var useWindowScroll_1 = __importDefault(require("./useWindowScroll"));
var useBottomCTA = function (boundaries) {
    var scrollY = (0, useWindowScroll_1.default)().y;
    var prevScrollY = (0, react_2.useRef)(0);
    var isVisible = (0, react_2.useMemo)(function () {
        var _a, _b;
        var isBottomDirection = prevScrollY.current < scrollY;
        var scrollMaxY = window.document.documentElement.offsetHeight -
            window.innerHeight -
            (((_a = boundaries.visibility) === null || _a === void 0 ? void 0 : _a.bottomHeight) || 0);
        var isInsideBoundary = (((_b = boundaries.visibility) === null || _b === void 0 ? void 0 : _b.topHeight) || 0) < scrollY && scrollY < scrollMaxY;
        prevScrollY.current = scrollY;
        return isInsideBoundary && isBottomDirection;
    }, [scrollY, boundaries]);
    var noAnimation = (0, react_2.useMemo)(function () {
        var _a;
        if (!boundaries.noAnimation) {
            return false;
        }
        var isBottomDirection = prevScrollY.current < scrollY;
        var isBottom = window.document.documentElement.offsetHeight -
            window.innerHeight -
            (((_a = boundaries.noAnimation) === null || _a === void 0 ? void 0 : _a.bottomHeight) || 0) <
            scrollY;
        return isBottom && !isBottomDirection;
    }, [scrollY, boundaries]);
    return { isVisible: isVisible, noAnimation: noAnimation };
};
exports.default = useBottomCTA;
